import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1688f60c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports